import { Component, HostListener } from '@angular/core';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

@Component({
  selector: 'app-billingoverduenotification',
  templateUrl: './billingoverdue.component.html',
  styleUrls: ['./billingoverdue.component.css'],
})
export class BillingoverdueComponent {
  isOpen = false;

  toggle(): void {
    this.isOpen = !this.isOpen;
  }

  close(event: MouseEvent): void {
    event.stopPropagation();
    this.isOpen = false;
  }

  @HostListener('document:click', ['$event'])
  onOutsideClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (!target.closest('.billing-banner') && !target.closest('.billing-trigger')) {
      this.isOpen = false;
    }
  }
}
